import React from "react";
import { secondaryColor } from "../../../data-service/backend-functions/helpers";
import clock from "../../../images/icon/clock.svg";
import networking from "../../../images/icon/networking.svg";
import speaker from "../../../images/icon/speaker.svg";
import { Card } from "../card.jsx";
const advantages = [
  {
    icon: speaker,
    title: "Decreasing Access to Physicians",
    text: "Physician access has been on the decline for years—a trend that started well before the pandemic and continues today.",
  },
  {
    icon: clock,
    title: "Limited Time and Stricter Policies",
    text: "Time constraints and institutional policies make it harder than ever for HCPs to engage with sales teams.",
  },
  {
    icon: networking,
    title: "Marketing Teams Take the Lead",
    text: "With reduced access for sellers, marketing now plays a critical role in reaching and engaging HCPs.",
  },
];

export const Advantages = () => {
  return (
    <div className="mt-50 container">
      <h2 style={{ color: secondaryColor }} className="mb-20 text-start">
        Why HCP Marketing is More Important Than Ever
      </h2>
      <div
        style={{
          display: "flex",
          alignItems: "stretch",
          justifyContent: "center",
          margin: "0,auto",
          gap: "30px",
          justifySelf: "center",
        }}
        className="advantages"
      >
        {advantages.map((advantage) => (
          <Card
            icon={advantage.icon}
            title={advantage.title}
            text={advantage.text}
            minHeight="400px"
          />
        ))}
      </div>
    </div>
  );
};
